/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BlogCardsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { FeaturedBlogCards } from "./FeaturedBlogCards.organism";
import React from "react";

export interface FeaturedBlogCardsSectionProps extends BlogCardsSectionFragment {
	className?: string;
}

export const FeaturedBlogCardsSection = ({
	config,
	cards,
}: FeaturedBlogCardsSectionProps): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack
						alignItems="stretch"
						gap="eds.dimension.48"
						className={cx("feature-blog-cards-section", css({ smDown: { gap: "eds.dimension.40" } }))}
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <FeaturedBlogCards cards={cards || []} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
